import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { response as res } from '../app.service';

@Injectable({
  providedIn: 'root'
})
export class DoctorSRVService {

  base: string = environment.baseUrl;

  api: string = environment.baseUrl + "hcp/patient";

  env: string = environment.baseUrl + "Relative";

  constructor(private http: HttpClient) { }

  getHcpById = (id: number) => this.http.get<res>(this.api + `/${id}`)

  patchAccount = (payload: FormData) => this.http.patch<res>(this.base + `Account/update`, payload);

  refreshToken = (payload: FormData) => this.http.post<res>(this.base + `Account/refreshToken`, payload);

  getAssignments = (req: String) => this.http.get<res>(this.base + "Assignment?" + req);

  getHcpVisits = (req: Object) => this.http.post<res>(this.base + "hcp/visit/search", req);

  startSession = (id: number) => this.http.post<res>(this.base + "hcp/visit/startSession/" + id, null);

  cancelSession = (id: number) => this.http.post<res>(this.base + "hcp/visit/cancel/" + id, null);

  completeVisit = (visitId) => this.http.post<any>(this.base + "hcp/visit/complete/" + visitId, null);

  grantAccessByEmail = (payload: FormData) => this.http.post<res>(this.base + `Marketing/Agencies/Hcp/GrantByEmail`, payload);

  getAgenciesForHCP = () => this.http.get<res>(this.base + "Marketing/Agencies/Hcp/Get");

  revokeAgency = (id: number) => this.http.get<res>(this.base + "Marketing/Agencies/Hcp/Revoke/" + id);

}
